const BaseUrl2 = "https://gokulnair.com/levelup_backend/api/";
const BaseUrl = "https://panel.ravinimavat.com/sprucemicro/api/";
const BaseUrl3 =
  "https://lightgoldenrodyellow-okapi-586794.hostingersite.com/sprucemicro/api/";
// "https://lightgoldenrodyellow-okapi-586794.hostingersite.com/sprucemicro/api/";

export const products_url = BaseUrl + "get_products";
export const cheke_state = BaseUrl + "cheke_state";
export const add_user_check_product = BaseUrl + "add_user_check_product";
export const createOrder_test = BaseUrl + "createOrder_test";
export const createOrder_test_v2 = BaseUrl + "createOrder_test_v2";
export const contact_details_step_25 = BaseUrl + "contact_details_step_25";
export const get_product_details = BaseUrl + "get_product_details";
export const get_url_data = BaseUrl + "get_url_data";
export const check_coupons = BaseUrl + "check_coupons";
export const check_coupons_v2 = BaseUrl + "check_coupons_v2";
export const member_view = BaseUrl + "member_view";
export const check_plan_expiry_v2 = BaseUrl + "check_plan_expiry_v2";